import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ShieldOff } from "lucide-react";

/**
 * Página de acceso denegado con diseño elegante.
 */
const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to right, #f8f9fb, #e9ecf3)",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={6}>
            <Card className="text-center border-0 shadow rounded-4 p-4">
              <div className="d-flex justify-content-center align-items-center mb-3">
                <div
                  className="bg-opacity-25 rounded-circle d-flex justify-content-center align-items-center"
                  style={{
                    width: 90,
                    height: 90,
                    backgroundColor: "#dc3545",
                  }}
                >
                  <ShieldOff size={42} strokeWidth={2.5} color="#fff" />
                </div>
              </div>
              <Card.Body>
                <h2 className="text-danger fw-bold mb-3">Acceso Denegado</h2>
                <p className="text-muted fs-6 mb-4">
                  No tienes los permisos necesarios para ver esta página. <br />
                  Si crees que esto es un error, contacta al administrador del
                  sistema.
                </p>
                <Button
                  variant="outline-primary"
                  className="px-4 py-2 rounded-pill fw-semibold"
                  onClick={() => navigate("/dashboard")}
                >
                  Volver al Dashboard
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Unauthorized;
